"use client";

import { useEffect, useState, type ReactNode } from "react";
import Script from "next/script";

import { AppProvider } from "context/AppContext";
import { isLuHost } from "server/hosts";
import { useReinitHubspotCta } from "utils/hooks/useReinitHubspotCta";
import { scheduleGoogleTagManager } from "utils/thirdParty/googleTagManager";

const COOKIE_SCRIPT_ID_BE = "66c115363a8d2ea14e64b5dcac93f89c";
const COOKIE_SCRIPT_ID_LU = "c16a06fef87a1f4b5e2e92d504b38782";
interface ProvidersProps {
  children: ReactNode;
}

export default function Providers({ children }: ProvidersProps) {
  const [cookieScriptId, setCookieScriptId] = useState<string | null>(null);

  useReinitHubspotCta();

  useEffect(() => {
    const isLu = isLuHost(window.location.host);
    setCookieScriptId(isLu ? COOKIE_SCRIPT_ID_LU : COOKIE_SCRIPT_ID_BE);

    const gtmId = isLu ? process.env.NEXT_PUBLIC_GA_ID_LU : process.env.NEXT_PUBLIC_GA_ID_BE;
    if (gtmId) {
      scheduleGoogleTagManager(gtmId);
    }
  }, []);

  return (
    <AppProvider>
      {cookieScriptId ? (
        <Script
          id="cookie-script"
          src={`https://cdn.cookie-script.com/s/${cookieScriptId}.js`}
          strategy="afterInteractive"
        />
      ) : null}
      {children}
    </AppProvider>
  );
}
